
import { IBrandImageType, IBrandDefinition, IDSConfig } from '@state/dsconfig/types';
import { IBrandImage, IType, IOemFilter } from '@state/brandsImages/types';
import { flatten, isEqual, repeat } from 'lodash';
import { storageAccountName, containerNameBrands, containerName } from '@storage/azure-storage-blob';
import D from '@assets/themes/dimensions';
import { getBoundingsWithDelta } from './geometry';

const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;

export const imageFileTypes = [
  'image/png', 'image/jpeg'
];

export const fontFileTypes = [
  '.eot', '.ttf', '.otf', '.woff2',
  'image/svg+xml', 'font/ttf', 'font/otf', 'application/font-woff', 'application/font-woff2'
];

const imageType: string[] = ['VEHICLES', 'LOGOS', 'BACKGROUNDS', 'STOCKS'];

export const getLabelsFromSection = (section: string | undefined) => {
  let title = "Item";
  if (section) {
    title = section.slice(0, -1);
    title = title.charAt(0).toUpperCase() + title.slice(1);
    if (title !== "Logo" && title !== "Font" && title !== "Color") title = title + ' Image';
  }
  return title;
}

export const getArrayDepth = (arr: any): number => {
  return Array.isArray(arr) ? // if arr is an array, recurse over it
    1 + Math.max(...arr.map(getArrayDepth)) : 
    Array.isArray(arr.types) && arr.types.length ? // if arr is an object with a children property, recurse over the children
      1 + Math.max(...arr.types.map(getArrayDepth)) : 
      0; // otherwise, it's 0
}

export const addVehicleTypes = (item: IBrandImage, vehicleTypes: IBrandImageType) => {
  let searchYear =  vehicleTypes.types.find((type: IBrandImageType) => (type.value===item.year??""));
  if (searchYear===undefined)  vehicleTypes.types.push({value: item.year??"", types: [], labels: [], ids:[]});
  vehicleTypes.types?.forEach((yearItem: IBrandImageType)=> {
    if (yearItem.value===item.year){
      let searchMake =  yearItem.types.find((type: IBrandImageType) => (type.value===item.make??""));
      if (searchMake===undefined)  yearItem.types.push({value: item.make??"", types: [], labels: [], ids:[]});
      yearItem.types?.forEach((makeItem: IBrandImageType)=> {
        if (makeItem.value===item.make){
          let searchModel =  makeItem.types.find((type: IBrandImageType) => (type.value===item.model??""));
          if (searchModel===undefined)  makeItem.types.push({value: item.model??"", types: [], labels: [], ids:[]});
          makeItem.types?.forEach((trimItem: IBrandImageType)=> {
            let searchTrim =  trimItem.types.find((type: IBrandImageType) => (type.value===item.trim??""));
            if (searchTrim===undefined)  trimItem.types.push({value: item.trim??"", types: [], labels: [], ids:[]});
          });
        }
      });
    }
  });
  return vehicleTypes;
}


export const getListVehicles = (types: IBrandImageType[], id: string) => {
  if (id==="year") return [types[0]??[]];
  else if (id==="type") return [types[1]??[]];
  else {
    let list: IBrandImageType[] = [];
    let listClear: IBrandImageType[] = [];
    types.forEach((yearItem: IBrandImageType)=> {
      if (id=="make") list.push(...yearItem.types);
      else yearItem.types?.forEach((makeItem: IBrandImageType)=> {
            if (id=="model") {
              list.push(...makeItem.types);
            } else makeItem.types?.forEach((modelItem: IBrandImageType)=> {
              if (id=="trim") list.push(...modelItem.types);
            });
          });
    });
    
    return list;
  }
}

export const getListLogos = (types: IOemFilter[], id: string, selectedFilters: IType[]) => {
  let oemsSelected = selectedFilters.filter((filter: IType)=> filter.id==="oem");
  let typeOnly = selectedFilters.filter((filter: IType)=> filter.id==="type");
  let yearOnly = selectedFilters.filter((filter: IType)=> filter.id==="year");
  let modelOnly = selectedFilters.filter((filter: IType)=> filter.id==="model");

  if (id==="year") {
    let yearsTypes: IBrandImageType[] = [];
    types.forEach ( (filter: IOemFilter ) => {//brand
      let parentSelected: IType|undefined = oemsSelected.find((typeSearc: IType) => filter.id===typeSearc.value);
      if (oemsSelected.length===0 || (oemsSelected.length>0 && parentSelected)) {
      filter.types?.forEach ( (filterType: IType ) => {//types
        let parentSelected = typeOnly.find((typeSearc: IType) => filterType.id===typeSearc.id && filterType.value===typeSearc.value);
        if (typeOnly.length>0 && parentSelected) {
          filterType.types?.forEach ( (filterYear: IType ) => {//year
            if (filterYear.id==='year') {
              let add: boolean = childSelected(modelOnly, filterYear);
              let yearAdded = yearsTypes.find((yearAdd: IBrandImageType) => filterYear.value===yearAdd.value);
              if (add && yearAdded===undefined) {
                yearsTypes.push({
                  value: filterYear.value,
                  types: [],
                  isInput: false,
                  labels: ['Year'],
                  ids: []
                });
              }
            }
          });
        }
      });
      }
    });
    return [{
      value: "year",
      types: yearsTypes,
      isInput: false,
      labels: ['Year'],
      ids: ["year"]
    }];
  } 
  if (id==="model") {
    let modelsTypes: IBrandImageType[] = [];
    types.forEach ( (filter: IOemFilter ) => {//brand
      let parentSelected: IType|undefined = oemsSelected.find((typeSearc: IType) => filter.id===typeSearc.value);
      if (oemsSelected.length===0 || (oemsSelected.length>0 && parentSelected)) {
      filter.types?.forEach ( (filterType: IType ) => {//type
        let parentSelected = typeOnly.find((typeSearc: IType) => filterType.id===typeSearc.id && filterType.value===typeSearc.value);
        if (typeOnly.length>0 && parentSelected) {
          filterType.types?.forEach ( (filterYear: IType ) => {//year
            let modelAdded = modelsTypes.find((modelAdd: IBrandImageType) => filterYear.value===modelAdd.value);
            if (filterYear.id==='model' && modelAdded===undefined) 
              modelsTypes.push({
                value: filterYear.value,
                types: [],
                isInput: false,
                labels: ['Model'],
                ids: []
              });
            else {
              let parentYearSelected = yearOnly.find((searchYear: IType) => filterYear.id===searchYear.id && filterYear.value===searchYear.value);
              if (yearOnly.length>0 && parentYearSelected) {
                filterYear.types?.forEach ( (filterModel: IType ) => {//model
                  let modelAdded = modelsTypes.find((modelAdd: IBrandImageType) => filterModel.value===modelAdd.value);
                  if (modelAdded===undefined)
                    modelsTypes.push({
                      value: filterModel.value,
                      types: [],
                      isInput: false,
                      labels: ['Model'],
                      ids: []
                    });
                });
              }
            }
          });
        }
      });
      }
    });
    return [{
      value: "model",
      types: modelsTypes,
      isInput: false,
      labels: ['Model'],
      ids: ["model"]
    }];
  } 
  else return [];
}

const childSelected = (children: IType[], parent: IType, ) => {
  let childSelected: boolean = false;
  if (children.length>0) {
    parent.types?.forEach ( (modelYear: IType ) => {
      children?.forEach ( (modelSelected: IType ) => {
        if (modelYear.id===modelSelected.id && modelYear.value===modelSelected.value) childSelected = true;
      });
    });
  } else childSelected = true;
  return childSelected;
}
export const validateVehicle =  (selectedFilters: any, field: string, brandItem: any ) => {
  let vehicleFilters: IType[] = selectedFilters.filter((itemType: IType) => itemType.id===field );
  let addValue = true;
  if (vehicleFilters.length>0){
    if (vehicleFilters.find((filter: IType) => filter.value ===brandItem[field])===undefined) addValue =  false;
  }
  return addValue;
}


export const vehicleFilterstoShow = (selectedFilters: any, types: IBrandImageType, typeFilters: IType[], listKepp: any ) => {
  let  typesNew : IType[] = typeFilters.filter((itemType: IType) => itemType.id==="type" || itemType.id==="subtype");

  let vehicleFiltersYear: IType[] = selectedFilters.filter((itemType: IType) => itemType.id==="year");
  let vehicleFiltersMake: IType[] = selectedFilters.filter((itemType: IType) => itemType.id==="make");
  let vehicleFiltersModel: IType[] = selectedFilters.filter((itemType: IType) => itemType.id==="model");
  let vehicleFiltersTrim: IType[] = selectedFilters.filter((itemType: IType) => itemType.id==="trim");
  
  types.types.forEach((typeYear: IBrandImageType) => {
    let addYear = false;
    let selectedYear = vehicleFiltersYear.find((searchYear: IType) => typeYear.value===searchYear.value);
    if (vehicleFiltersYear.length==0 || selectedYear) {
      typeYear.types.forEach((typeMake: IBrandImageType) => {
        let addMake = false;
        let selectedMake = vehicleFiltersMake.find((searchMake: IType) => typeMake.value===searchMake.value);  
        if (vehicleFiltersMake.length==0 || selectedMake) {
            typeMake.types.forEach((typeModel: IBrandImageType) => {
                let addModel = false; 
                if (vehicleFiltersModel.length==0 || vehicleFiltersModel.find((searchModel: IType) => typeModel.value===searchModel.value)) {
                  typeModel.types.forEach((typeTrim: IBrandImageType) => { 
                      let addTrim = false;
                      let selectedTrim = vehicleFiltersTrim.find((searchTrim: IType) => typeTrim.value===searchTrim.value);  
                      if (vehicleFiltersTrim.length==0 || selectedTrim) addTrim =  true;
                      
                      if (addTrim) addModel = true;
                      if (addTrim || keepOnList(listKepp,"trim", typeTrim.value)) typesNew.push({id: "trim", value: typeTrim.value});
                      
                  });
                }
                if (addModel) addMake = true; 
                if (addModel || keepOnList(listKepp,"model", typeModel.value) || selectedMake) typesNew.push({id: "model", value: typeModel.value}); 
            });
        }
        if (addMake) addYear = true;
        if (addMake || keepOnList(listKepp,"make", typeMake.value) || selectedYear || vehicleFiltersYear.length==0) typesNew.push({id: "make", value: typeMake.value});
      });
    }
    if (addYear || keepOnList(listKepp,"year", typeYear.value)) typesNew.push({id: "year", value: typeYear.value});
  });

  return typesNew;
}

export const keepOnList = (keepInfo: any , field: string, valueSearch: string) => {
  return (keepInfo.column === field && keepInfo.list?.find((value: string) => valueSearch===value));
}

export const getImageSrc = (data:IBrandImage)=>{
  if (data.id=="" || data.id== undefined)
    return data.srcImage;
  else
  {      
    return `${urlBrand}/${data.brandId}/${data.imageType?data.imageType.toLowerCase():""}/${data.srcImage}` + "TN";
  }
}

export const handleBrandImageLoad = (e: any, id: string, imagesList: IBrandImage[]) => {
  const recalculatedSizes = getBoundingsWithDelta(0, e.target.offsetWidth, e.target.offsetHeight, D.BRAND_ITEM_WIDTH, D.BRAND_ITEM_HEIGHT);
  const imageIndex = imagesList.findIndex(image => image.id === id);
  if (imageIndex >= 0) {
    return[
      ...imagesList.slice(0, imageIndex),
      {...imagesList[imageIndex], ...recalculatedSizes},
      ...imagesList.slice(imageIndex + 1)
    ];
  } else return imagesList;
}

export const getImageSize = (e: any, iWidth: number | undefined, iHeight: number | undefined, imageInfo: IBrandImage) => {
  const ratioTrigger = 2;
  const initWidth = iWidth ?? e.target.offsetWidth, initHeight = iHeight ?? e.target.offsetHeight;
  let width = initWidth, height = initHeight;
  const ratio = height > 0 ? width/height : ratioTrigger;
  if (ratio >= ratioTrigger) {
    width = 215;
    height = width/ratio;
  } else {
    width = 100;
    height = width/ratio;
  }
  return {...imageInfo,  width: width, height: height, initWidth, initHeight};
}

export const handleImageError = (id: string, imagesList: IBrandImage[]) => {
  return imagesList.filter((image:IBrandImage ) => image.id!==id);
}

export const getOEMDefault = (entityInformation: any, dsConfig: IDSConfig) => {
  let oem: string = entityInformation.tags?.oem;
  let oemDefault : IBrandDefinition|undefined = undefined;
  oemDefault = dsConfig.brands.find((oemItem: IBrandDefinition) => {
    if ((oem==='' || oem===null || oem===undefined) && oemItem.useAsCommon) return oemItem;
    else if (oemItem.id===oem) return oemItem;
  });
  return oemDefault;
}

export const brandSearchResults = (searchResults: IBrandImage[], searchValue: string) => {
  searchValue = searchValue.toLocaleLowerCase();
  let orderesdList: any[] = [];
  imageType.forEach((type: string) => {
      let imagesGroupType: IBrandImage[] = searchResults.filter((item: IBrandImage) => item.imageType===type);
      imagesGroupType.forEach((image: IBrandImage) => { 
        let listTypes : any = {}; 
        listTypes = {...listTypes, imageType: image.imageType};
        let added : boolean = false;

        image.types?.forEach((type: IType) => {
          if (type.id==="type") listTypes = {...listTypes , [`${type.id}`]: type.value }
          if (type.id==="type" && type.value.toLocaleLowerCase().includes(searchValue)) added = true;
        });
        image.themes?.forEach((type: IType) => {
          if (type.id==="theme") listTypes = {...listTypes , [`${type.id}`]: type.value }
          if (type.id==="theme" && type.value.toLocaleLowerCase().includes(searchValue)) added = true;
        });

        if (!added) {
          image.tags?.forEach((tag: string) => {
            if (tag.toLocaleLowerCase().includes(searchValue)) listTypes = {...listTypes , tag: tag }
          });
        }

        let searchRepeat = orderesdList.find((item: any) => isEqual(item, listTypes));
        if (!searchRepeat) orderesdList.push(listTypes);
      })
  });
  let typeResults: any[] = orderesdList.filter((item: any) => !item.tag);
  let tagResults: any[] = orderesdList.filter((item: any) => item.tag);
  return [...typeResults, ...tagResults]
}

export const getSearchResultGroup = (searchResults: IBrandImage[], searchValue: any) => {
  let orderesdList: IBrandImage[] = [];
  imageType.forEach((type: string) => {
      let imagesGroupType: IBrandImage[] = searchResults.filter((item: IBrandImage) => item.imageType===type);
      imagesGroupType.forEach((image: IBrandImage) => {
        let add = false;
        image.types?.forEach((type: IType) => {
          if (type.id==="type" && searchValue.type && type.value===searchValue.type) add = true; 
          if (type.id==="theme" && searchValue.theme && type.value ===searchValue.theme) add = true; 
        });
        
        if (searchValue.tag  && !image.tags?.find((tag: string) => tag.toLocaleLowerCase()===searchValue.tag.toLocaleLowerCase())) add = false;
        
        if (add) orderesdList.push(image);
      })
  });
  return orderesdList
}

export const validateYear = (value: string) => {
  if (value === "") return true;
  if (value.length < 5) {
    let intValue = parseInt(value);
    if (!isNaN(intValue)) {
      const maxYear = (new Date()).getFullYear() + 1;
      if (intValue <= maxYear) return true;
    }
  }
  return false;
}


export const getBrandsINquery = (brands: any[]) => {
  let brandIn: string = ` c.brandId IN (`;
  brands.forEach((brand: any, idx: number) => {
      if (brand.id && brand.id!==null) brandIn+=`'${brand.id}',`;
  })
  brandIn = brandIn.slice(0, -1); 
  brandIn = brandIn + `)`;
  return brandIn;
}